export const IndexV2Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_reserve', internalType: 'Currency', type: 'address' },
      { name: '_governance', internalType: 'address', type: 'address' },
      { name: '_messenger', internalType: 'address', type: 'address' },
      { name: '_maxDepositFeeInBPs', internalType: 'uint16', type: 'uint16' },
      {
        name: '_maxRedemptionFeeInBPs',
        internalType: 'uint16',
        type: 'uint16',
      },
      {
        name: '_maxAUMDilutionPerSecond',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'recipient', internalType: 'address', type: 'address' }],
    name: 'accrueFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'amount', internalType: 'uint96', type: 'uint96' },
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'consume',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct IIndex.DepositParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IIndex.DepositConfig',
            type: 'tuple',
            components: [
              {
                name: 'shared',
                internalType: 'struct IIndex.Config',
                type: 'tuple',
                components: [
                  {
                    name: 'latestSnapshot',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'AUMDilutionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'useCustomAUMFee',
                    internalType: 'bool',
                    type: 'bool',
                  },
                  {
                    name: 'staticPriceOracle',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'metadata',
                    internalType: 'address',
                    type: 'address',
                  },
                ],
              },
              {
                name: 'fee',
                internalType: 'struct IIndex.FeeConfig',
                type: 'tuple',
                components: [
                  { name: 'BPs', internalType: 'uint16', type: 'uint16' },
                  {
                    name: 'useCustomCallback',
                    internalType: 'bool',
                    type: 'bool',
                  },
                ],
              },
            ],
          },
          { name: 'recipient', internalType: 'address', type: 'address' },
          { name: 'payload', internalType: 'bytes', type: 'bytes' },
        ],
      },
      { name: 'cbTarget', internalType: 'address', type: 'address' },
      { name: 'cbData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'deposit',
    outputs: [{ name: 'shares', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'donate',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'slot', internalType: 'bytes32', type: 'bytes32' }],
    name: 'extsload',
    outputs: [{ name: 'value', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'slots', internalType: 'bytes32[]', type: 'bytes32[]' }],
    name: 'extsload',
    outputs: [{ name: '', internalType: 'bytes32[]', type: 'bytes32[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'fees',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct IVault.EndRebalancingParams',
        type: 'tuple',
        components: [
          {
            name: 'anatomyCurrencies',
            internalType: 'a160u96[]',
            type: 'uint256[]',
          },
          {
            name: 'newAnatomy',
            internalType: 'struct IVault.SnapshotAnatomy',
            type: 'tuple',
            components: [
              {
                name: 'currencies',
                internalType: 'a160u96[]',
                type: 'uint256[]',
              },
              {
                name: 'currencyIndexSet',
                internalType: 'uint256[]',
                type: 'uint256[]',
              },
            ],
          },
          {
            name: 'withdrawals',
            internalType: 'struct IVault.CurrencyWithdrawal',
            type: 'tuple',
            components: [
              {
                name: 'currencyIndexSet',
                internalType: 'uint256[]',
                type: 'uint256[]',
              },
              { name: 'amounts', internalType: 'uint96[]', type: 'uint96[]' },
            ],
          },
          { name: 'lastKBalance', internalType: 'uint256', type: 'uint256' },
          { name: 'currencies', internalType: 'Currency[]', type: 'address[]' },
        ],
      },
    ],
    name: 'finishRebalancingPhase',
    outputs: [{ name: 'resultHash', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'kBalanceWads',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'kSelf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct IIndex.RedemptionParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IIndex.RedemptionConfig',
            type: 'tuple',
            components: [
              {
                name: 'shared',
                internalType: 'struct IIndex.Config',
                type: 'tuple',
                components: [
                  {
                    name: 'latestSnapshot',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'AUMDilutionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'useCustomAUMFee',
                    internalType: 'bool',
                    type: 'bool',
                  },
                  {
                    name: 'staticPriceOracle',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'metadata',
                    internalType: 'address',
                    type: 'address',
                  },
                ],
              },
              {
                name: 'fee',
                internalType: 'struct IIndex.FeeConfig',
                type: 'tuple',
                components: [
                  { name: 'BPs', internalType: 'uint16', type: 'uint16' },
                  {
                    name: 'useCustomCallback',
                    internalType: 'bool',
                    type: 'bool',
                  },
                ],
              },
              { name: 'forwarder', internalType: 'address', type: 'address' },
              {
                name: 'homeCurrencies',
                internalType: 'a160u96[]',
                type: 'uint256[]',
              },
            ],
          },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'shares', internalType: 'uint128', type: 'uint128' },
          { name: 'payload', internalType: 'bytes', type: 'bytes' },
        ],
      },
      { name: 'forwardedSender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
    ],
    name: 'redeem',
    outputs: [
      {
        name: 'result',
        internalType: 'struct IIndex.RedemptionInfo',
        type: 'tuple',
        components: [
          {
            name: 'reserveValuation',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'totalValuation', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalReserveShares',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'totalSupplyAfterAUMAccrual',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'totalKBeforeRedeem',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'accountBalanceSharesBeforeRedeem',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'accountReserveRedeemed',
            internalType: 'uint96',
            type: 'uint96',
          },
          {
            name: 'accountReserveSharesRedeemed',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'accountKRedeemed',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'reservePriceInQ128',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'currencies', internalType: 'Currency[]', type: 'address[]' }],
    name: 'registerCurrencies',
    outputs: [
      {
        name: 'result',
        internalType: 'struct IVault.RegisterCurrenciesResult',
        type: 'tuple',
        components: [
          { name: 'currencies', internalType: 'Currency[]', type: 'address[]' },
          { name: 'currenciesHash', internalType: 'bytes32', type: 'bytes32' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'reserve',
    outputs: [{ name: '', internalType: 'Currency', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'reserveBalance',
    outputs: [{ name: '', internalType: 'uint96', type: 'uint96' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_prevConfig',
        internalType: 'struct IIndex.Config',
        type: 'tuple',
        components: [
          { name: 'latestSnapshot', internalType: 'uint256', type: 'uint256' },
          {
            name: 'AUMDilutionPerSecond',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'useCustomAUMFee', internalType: 'bool', type: 'bool' },
          {
            name: 'staticPriceOracle',
            internalType: 'address',
            type: 'address',
          },
          { name: 'metadata', internalType: 'address', type: 'address' },
        ],
      },
      {
        name: '_depositConfig',
        internalType: 'struct IIndex.DepositConfig',
        type: 'tuple',
        components: [
          {
            name: 'shared',
            internalType: 'struct IIndex.Config',
            type: 'tuple',
            components: [
              {
                name: 'latestSnapshot',
                internalType: 'uint256',
                type: 'uint256',
              },
              {
                name: 'AUMDilutionPerSecond',
                internalType: 'uint256',
                type: 'uint256',
              },
              { name: 'useCustomAUMFee', internalType: 'bool', type: 'bool' },
              {
                name: 'staticPriceOracle',
                internalType: 'address',
                type: 'address',
              },
              { name: 'metadata', internalType: 'address', type: 'address' },
            ],
          },
          {
            name: 'fee',
            internalType: 'struct IIndex.FeeConfig',
            type: 'tuple',
            components: [
              { name: 'BPs', internalType: 'uint16', type: 'uint16' },
              { name: 'useCustomCallback', internalType: 'bool', type: 'bool' },
            ],
          },
        ],
      },
      {
        name: '_redemptionConfig',
        internalType: 'struct IIndex.RedemptionConfig',
        type: 'tuple',
        components: [
          {
            name: 'shared',
            internalType: 'struct IIndex.Config',
            type: 'tuple',
            components: [
              {
                name: 'latestSnapshot',
                internalType: 'uint256',
                type: 'uint256',
              },
              {
                name: 'AUMDilutionPerSecond',
                internalType: 'uint256',
                type: 'uint256',
              },
              { name: 'useCustomAUMFee', internalType: 'bool', type: 'bool' },
              {
                name: 'staticPriceOracle',
                internalType: 'address',
                type: 'address',
              },
              { name: 'metadata', internalType: 'address', type: 'address' },
            ],
          },
          {
            name: 'fee',
            internalType: 'struct IIndex.FeeConfig',
            type: 'tuple',
            components: [
              { name: 'BPs', internalType: 'uint16', type: 'uint16' },
              { name: 'useCustomCallback', internalType: 'bool', type: 'bool' },
            ],
          },
          { name: 'forwarder', internalType: 'address', type: 'address' },
          {
            name: 'homeCurrencies',
            internalType: 'a160u96[]',
            type: 'uint256[]',
          },
        ],
      },
    ],
    name: 'setConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_feePool', internalType: 'address', type: 'address' }],
    name: 'setFeePool',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_messenger', internalType: 'address', type: 'address' }],
    name: 'setMessenger',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_orderBook', internalType: 'address', type: 'address' }],
    name: 'setOrderBook',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'startIndexRebalancing',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'withdrawals',
        internalType: 'struct IVault.CurrencyWithdrawal',
        type: 'tuple',
        components: [
          {
            name: 'currencyIndexSet',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
          { name: 'amounts', internalType: 'uint96[]', type: 'uint96[]' },
        ],
      },
    ],
    name: 'startRebalancingPhase',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'kAmountWads', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferLatestSnapshot',
    outputs: [{ name: 'snapshot', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'snapshot', internalType: 'uint256', type: 'uint256' },
      { name: 'kAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'recipient', internalType: 'address', type: 'address' },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'encodedConfig',
        internalType: 'bytes',
        type: 'bytes',
        indexed: false,
      },
    ],
    name: 'ConfigUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'currency',
        internalType: 'Currency',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Consume',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'reserve',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'shares',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Deposit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'currency',
        internalType: 'Currency',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Donate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'depositFee',
        internalType: 'uint96',
        type: 'uint96',
        indexed: false,
      },
      {
        name: 'redemptionFee',
        internalType: 'uint96',
        type: 'uint96',
        indexed: false,
      },
      {
        name: 'AUMFee',
        internalType: 'uint96',
        type: 'uint96',
        indexed: false,
      },
    ],
    name: 'FeeAccrued',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [{ name: 'fee', internalType: 'uint96', type: 'uint96', indexed: false }],
    name: 'FeeSettled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'snapshot',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currencies',
        internalType: 'a160u96[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'FinishRebalancing',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'snapshot',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'SnapshotTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'snapshot',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'kBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'withdrawals',
        internalType: 'struct IVault.CurrencyWithdrawal',
        type: 'tuple',
        components: [
          {
            name: 'currencyIndexSet',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
          { name: 'amounts', internalType: 'uint96[]', type: 'uint96[]' },
        ],
        indexed: false,
      },
    ],
    name: 'StartRebalancing',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'receiver',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'shares',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'k', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'reserve',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Withdraw',
  },
  { type: 'error', inputs: [], name: 'CurrenciesHashMismatch' },
  { type: 'error', inputs: [], name: 'ERC20TransferFailed' },
  {
    type: 'error',
    inputs: [{ name: 'currencyIndex', internalType: 'uint256', type: 'uint256' }],
    name: 'ExcessNewAnatomyCurrencyIndex',
  },
  { type: 'error', inputs: [], name: 'FeeExceedsMaxFee' },
  { type: 'error', inputs: [], name: 'Forbidden' },
  { type: 'error', inputs: [], name: 'HashMismatch' },
  { type: 'error', inputs: [], name: 'IndexConfigHash' },
  { type: 'error', inputs: [], name: 'IndexConfigMismatch' },
  { type: 'error', inputs: [], name: 'IndexInitialConfig' },
  { type: 'error', inputs: [], name: 'InvalidSender' },
  { type: 'error', inputs: [], name: 'InvalidSigner' },
  { type: 'error', inputs: [], name: 'InvalidWithdrawal' },
  { type: 'error', inputs: [], name: 'NativeTransferFailed' },
  {
    type: 'error',
    inputs: [{ name: 'expectedCount', internalType: 'uint256', type: 'uint256' }],
    name: 'NewAnatomyCurrencyCountMismatch',
  },
  {
    type: 'error',
    inputs: [{ name: 'currencyIndex', internalType: 'uint256', type: 'uint256' }],
    name: 'NewAnatomyCurrencyIndexNotFound',
  },
  {
    type: 'error',
    inputs: [{ name: 'expectedCount', internalType: 'uint256', type: 'uint256' }],
    name: 'NewAnatomyCurrencyIndexSetSizeMismatch',
  },
  {
    type: 'error',
    inputs: [{ name: 'expectedCurrency', internalType: 'a160u96', type: 'uint256' }],
    name: 'NewAnatomyCurrencyMismatch',
  },
  { type: 'error', inputs: [], name: 'PermitDeadlineExpired' },
  { type: 'error', inputs: [], name: 'Rebalancing' },
  {
    type: 'error',
    inputs: [{ name: 'currency', internalType: 'Currency', type: 'address' }],
    name: 'Registered',
  },
  { type: 'error', inputs: [], name: 'ZeroAddressTransfer' },
  { type: 'error', inputs: [], name: 'ZeroDeposit' },
  { type: 'error', inputs: [], name: 'ZeroShares' },
] as const
